module.exports = __webpack_public_path__ + "img/download.411f522c.svg";